// extracted by mini-css-extract-plugin
export default {"afterPayModeSection":"F7-z","refreshPageWarning":"G7-z","redirectMessageText":"H7-z"};